import {Injectable} from '@angular/core';
import {FeeOptionRepository} from "../repositories/fee-option.repository";
import {Constants} from "../utils/constants";
import {Utilities} from "../utils/utilities";
import {BaseService} from "./common/base.service";
import {FilterService} from "./filterer/filter.service";
import {DataManipulationService} from "./common/data-manipulation.service";
import {TranslateService} from "@ngx-translate/core";
import {ValidatorService} from "./common/validator.service";

@Injectable({
    providedIn: 'root'
})
export class FeeOptionService extends BaseService<FeeOptionRepository> {


    constructor(repo: FeeOptionRepository, filterService: FilterService, dataManipulationService: DataManipulationService, validatorService: ValidatorService) {
        super(repo, filterService, dataManipulationService, validatorService);
        this.typeName = 'FeeOption';
    }

    getAllForRestaurantHistory(restaurantHistoryId: number) {
        return this.repo.getAllForRestaurantHistory(restaurantHistoryId);
    }

    validate(feeOption: BaseFeeOption) {
        if (feeOption.period < 1) {
            throw new Error("error.feeOptions.periodIsEmpty");
        }
        if (feeOption.periodType.length < 1) {
            throw new Error("error.feeOptions.periodTypeIsEmpty");
        }
        if (feeOption.feeDetailsList.length < 1) {
            throw new Error("error.feeDetails.isEmpty");
        }
        let count = 0;
        feeOption.feeDetailsList.forEach(feeDetails => {
            if (feeDetails.percent < 1 || feeDetails.currency.length < 1 || feeDetails.value < 0) {
                throw new Error("error.feeDetails.invalidOptions");
            }
            if (feeDetails.base) {
                count++;
            }
        });
        if (count > 1) {
            throw new Error("error.feeDetails.moreThenOneBase");
        }
        if (count < 1) {
            throw new Error("error.feeDetails.notBaseDetails");
        }

    }

    saveOrUpdate(feeOption: BaseFeeOption) {
        if (feeOption.id == null) {
            return this.save(feeOption)
        } else {
            return this.update(feeOption);
        }
    }

    associateRestaurantHistory(restaurantHistoryId: any, id: any) {
        const path = "dashboard/admin/restaurant-histories/" + restaurantHistoryId + "/fee-options/" + id;
        return this.repo.patch(path);
    }
}

export class BaseFeeOption {
    id: number = null;
    type: string;
    lastRun: Date;
    periodType: string;
    period: number;
    name: string;
    feeDetailsList: BaseFeeDetails[];
    notes: any[];

    constructor(key: string) {
        this.type = key;
        this.lastRun = new Date();
        this.periodType = Constants.FEE_PERIOD_TYPE.MONTH;
        this.period = 2;
        this.name = "";
        this.feeDetailsList = [];
        this.notes = [];
    }
}

export class BaseFeeDetails {
    base: boolean = false;
    startDate: Date;
    endDate: Date;
    percent: number;
    value: number;
    currency: string;

    //feeDiscounts:BaseFeeDiscount[];

    constructor() {
        this.startDate = new Date();
        this.endDate = Utilities.addDays(new Date(), 365);
        this.percent = 10;
        this.value = 100000;
        this.currency = "huf";
        //this.feeDiscounts = [];
    }
}

export class BaseFeeDiscount {
    percent: number;
    value: number;
    minEdge: number;
    maxEdge: number;
}
